import { defineComponent as _defineComponent } from 'vue'
import { vShow as _vShow, createVNode as _createVNode, withDirectives as _withDirectives, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import SogForm from "@/shared/ui/SogForm.vue";
import GdvAccess from "@/shared/model/GdvAccess";
import {ref, watch} from "vue";
import copyTo from "@/shared/utils/CopyTo";
import SogFormField from "@/shared/ui/SogFormField.vue";
import SogTextBox from "@/shared/ui/SogTextBox.vue";
import SogSwitch from "@/shared/ui/SogSwitch.vue";
import SogNumericTextBox from "@/shared/ui/SogNumericTextBox.vue";
import SogDropDownList from "@/shared/ui/SogDropDownList.vue";
interface Props {
  data?:GdvAccess
  isCreate?:boolean
}
// eslint-disable-next-line @typescript-eslint/no-unused-vars

export default /*@__PURE__*/_defineComponent({
  __name: 'GdvAccessFormComponent',
  props: {
    data: { default: undefined },
    isCreate: { type: Boolean, default: false }
  },
  setup(__props: any, { expose: __expose }) {

const _modus = [
  {id:"PP", value:"PP für Produktionsnachrichten"},
  {id:"PT", value:"PT für im Produktionssystem notwendige gemeinsame Tests"},
  {id:"TU", value:"TU für unabhängige Tests"},
  {id:"TG", value:"TG für gemeinsame Tests"},
  {id:"Offline", value:"Offline"},
]
const props = __props
const _data = ref<GdvAccess>(new GdvAccess());
const _form = ref<InstanceType<typeof SogForm>  | null>(null)


watch((props),()=>{
  if (props.data) {
    copyTo(props.data, _data.value)
  }

},{immediate:true})



function validate():boolean{
  return _form.value?.validate()??false;
}

function getResults():GdvAccess{
  const res = new GdvAccess();
  copyTo(_data.value,res)
  return res;
}

__expose({
  getResults,validate
})



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(SogForm, {
    ref_key: "_form",
    ref: _form
  }, {
    default: _withCtx(() => [
      _createVNode(SogFormField, null, {
        default: _withCtx(() => [
          _withDirectives(_createVNode(SogTextBox, {
            modelValue: _data.value.id,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_data.value.id) = $event)),
            placeholder: "Id",
            name: "Id"
          }, null, 8, ["modelValue"]), [
            [_vShow, __props.isCreate]
          ]),
          _createVNode(SogTextBox, {
            modelValue: _data.value.userName,
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_data.value.userName) = $event)),
            placeholder: "Benutzername",
            name: "User name"
          }, null, 8, ["modelValue"])
        ]),
        _: 1
      }),
      _createVNode(SogFormField, null, {
        default: _withCtx(() => [
          _createVNode(SogTextBox, {
            modelValue: _data.value.description,
            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_data.value.description) = $event)),
            placeholder: "Beschreibung",
            name: "User name"
          }, null, 8, ["modelValue"])
        ]),
        _: 1
      }),
      _createVNode(SogFormField, null, {
        default: _withCtx(() => [
          _createVNode(SogDropDownList, {
            modelValue: _data.value.mode,
            "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_data.value.mode) = $event)),
            placeholder: _data.value.mode,
            name: "Modus",
            "data-source": _modus
          }, null, 8, ["modelValue", "placeholder"])
        ]),
        _: 1
      }),
      _createVNode(SogFormField, null, {
        default: _withCtx(() => [
          _createVNode(SogTextBox, {
            modelValue: _data.value.communicationPartnerIdentifer,
            "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_data.value.communicationPartnerIdentifer) = $event)),
            placeholder: "Kommunikationpartner Id",
            name: "Kommunikationpartner Id"
          }, null, 8, ["modelValue"])
        ]),
        _: 1
      }),
      _createVNode(SogFormField, null, {
        default: _withCtx(() => [
          _createVNode(SogNumericTextBox, {
            modelValue: _data.value.pinErrorAllowed,
            "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_data.value.pinErrorAllowed) = $event)),
            placeholder: "PIN erlaubte Fehlversuche",
            name: "pinErrorAllowed",
            format: "N"
          }, null, 8, ["modelValue"])
        ]),
        _: 1
      }),
      _createVNode(SogFormField, null, {
        default: _withCtx(() => [
          _createVNode(SogSwitch, {
            modelValue: _data.value.briefkasten,
            "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_data.value.briefkasten) = $event)),
            placeholder: "Briefkasten"
          }, null, 8, ["modelValue"])
        ]),
        _: 1
      }),
      _createVNode(SogFormField, null, {
        default: _withCtx(() => [
          _createVNode(SogTextBox, {
            modelValue: _data.value.transferBriefkastenIds,
            "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_data.value.transferBriefkastenIds) = $event)),
            placeholder: "Transferbriefkasten Ids"
          }, null, 8, ["modelValue"])
        ]),
        _: 1
      })
    ]),
    _: 1
  }, 512))
}
}

})